import { useId } from 'react';
import { Input } from '@/components/ui/input';
import type { CustomFieldProps } from './types';
import { CustomFieldLabel } from './custom-field-label';
import { CustomFieldHelperText } from './custom-field-helper-text';

export function CustomCurrencyFloatField({
  title,
  placeholder,
  onValueChange,
  value,
  disabled,
  required,
  description,
  error,
}: CustomFieldProps) {
  const id = useId();
  return (
    <div className='flex w-full flex-col gap-2 not-first:*:mt-2'>
      <CustomFieldLabel required={required} htmlFor={id}>
        {title}
      </CustomFieldLabel>
      <div className='flex rounded-md'>
        <Input
          id={id}
          value={value}
          disabled={disabled}
          onChange={(e) => onValueChange?.(e.target.value)}
          onWheel={(e) => e.preventDefault()}
          placeholder={placeholder || title}
          type='number'
          className='-me-px [appearance:textfield] rounded-e-none shadow-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none'
          step={0.1}
        />
        <span className='z-10 inline-flex items-center rounded-e-xl border border-input bg-surface px-4 text-sm text-muted-foreground'>
          SEK
        </span>
      </div>
      <CustomFieldHelperText error={error} description={description} />
    </div>
  );
}
